var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ToastsProvider } from 'tombac';
import { AuthApiClientProvider } from './authApi/AuthApiClientContext';
import { useMeQuery, useRefreshTokenMutation } from './authApi/authApiHooks';
import { LegolandApiClientProvider } from './legolandApi';
import { LegolandProvider } from './LegolandContext';
import { NewReleaseNotification } from './releaseNotes/NewReleaseNotification';
var AuthManager = function (_a) {
    var _b;
    var _c = _a.autoRefreshToken, autoRefreshToken = _c === void 0 ? true : _c, children = _a.children, _d = _a.refreshTokenInterval, refreshTokenInterval = _d === void 0 ? 60000 : _d;
    var meQuery = useMeQuery();
    var refreshToken = useRefreshTokenMutation().mutate;
    useEffect(function onMeChangeEffect() {
        if (!autoRefreshToken || !meQuery.isSuccess || meQuery.data.me === null) {
            return;
        }
        refreshToken();
        var interval = setInterval(refreshToken, refreshTokenInterval);
        return function () { return clearInterval(interval); };
    }, [
        autoRefreshToken,
        meQuery.isSuccess,
        (_b = meQuery.data) === null || _b === void 0 ? void 0 : _b.me,
        meQuery.dataUpdatedAt,
    ]);
    return React.createElement(React.Fragment, null, children);
};
export var queryClient = new QueryClient({
    defaultOptions: { queries: { staleTime: 2000 } },
});
var toastsProviderDefaults = {
    topOffset: 'navbar',
    zIndex: 10000,
};
export var LegolandApp = function (_a) {
    var children = _a.children, _b = _a.newReleaseNotifications, newReleaseNotifications = _b === void 0 ? true : _b, toastsProviderProps = _a.toastsProviderProps, rest = __rest(_a, ["children", "newReleaseNotifications", "toastsProviderProps"]);
    return (React.createElement(ToastsProvider, __assign({}, toastsProviderDefaults, toastsProviderProps),
        React.createElement(QueryClientProvider, { client: queryClient },
            React.createElement(LegolandProvider, __assign({}, rest),
                React.createElement(AuthApiClientProvider, null,
                    React.createElement(LegolandApiClientProvider, null,
                        React.createElement(AuthManager, __assign({}, rest),
                            newReleaseNotifications && rest.releaseNotesUrl && (React.createElement(NewReleaseNotification, null)),
                            children)))))));
};
//# sourceMappingURL=LegolandApp.js.map